import { render, staticRenderFns } from "./fileItem.vue?vue&type=template&id=0142586a&scoped=true"
import script from "./fileItem.vue?vue&type=script&lang=js"
export * from "./fileItem.vue?vue&type=script&lang=js"
import style0 from "./fileItem.vue?vue&type=style&index=0&id=0142586a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0142586a",
  null
  
)

export default component.exports